var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"condition-list"},_vm._l((_vm.benefits),function(benefit,index){return _c('li',{key:index,staticClass:"my-1 d-flex align-start"},[_c('v-icon',{staticClass:"mr-2 white",attrs:{"color":"primary"}},[_vm._v(" mdi-check-circle ")]),_c('div',[_vm._v(_vm._s(_vm.$t(benefit)))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }